import { Indicator, IndicatorProps } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

/** The highest count the badge shows. Screen reader labels use it too. */
export const MAX_DISPLAYED_COUNT = 99;

interface UnreadCountIndicatorProps extends Omit<IndicatorProps, "label"> {
  count: number;
}

/** A red badge with the unread message count, capped at 99. Renders nothing for zero. */
export default function UnreadCountIndicator({ count, ...props }: UnreadCountIndicatorProps) {
  if (count <= 0) return null;

  return (
    <Indicator
      size={16}
      color="red.7"
      label={
        <TextWrapper c="white" size="xs" variant="bold" aria-label="Unread messages">
          {Math.min(count, MAX_DISPLAYED_COUNT)}
        </TextWrapper>
      }
      {...props}
    />
  );
}
